'use client'

import { Badge } from '@/components/ui/shadcn/badge'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { getColorByPrimary, getDefaultColor } from '@/lib/utils/colors'

export default function UserGroupChip({
  userGroup,
  variant = 'filled',
  onClick,
  onDelete,
  className,
  ...props
}) {
  if (!userGroup) return null

  const color = getColorByPrimary(userGroup.color || getDefaultColor().primary)

  const style =
    variant === 'filled'
      ? {
          backgroundColor: color.primary,
          color: color.contrastText,
          borderColor: color.primary,
        }
      : {
          backgroundColor: 'transparent',
          color: color.primary,
          borderColor: color.primary,
        }

  return (
    <Badge
      variant="outline"
      className={cn(
        'inline-flex items-center gap-1 border',
        onClick && 'cursor-pointer',
        className,
      )}
      style={style}
      onClick={onClick}
      {...props}
    >
      {userGroup.name}
      {onDelete && (
        <button
          type="button"
          onClick={e => {
            e.stopPropagation()
            onDelete(e)
          }}
          className="inline-flex items-center justify-center rounded-full hover:opacity-75"
          aria-label="Remove"
        >
          <X className="size-3" />
        </button>
      )}
    </Badge>
  )
}
